import { render } from "./VehicleList.vue?vue&type=template&id=23e474e8&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"

import "./VehicleList.vue?vue&type=style&index=0&id=23e474e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e474e8"]])

export default __exports__